<template>
  <b-container class="page-container" fluid>
    <BogoCheckout :bogoType='bogoType' />
  </b-container>
</template>
<style>

</style>

<script>
// @ is an alias to /src
import BogoCheckout from "@/components/checkout/bogo/BogoCheckout.vue";

export default {
  title: 'Dropsmart Checkout - Buy One Get One',
  name: "Bogo",
  components: {
    BogoCheckout
  },
  props: {
    bogoType: {
      type: String,
      required: true
    }
  }
};
</script>
